import React, { useContext, useState } from 'react'
import Cookies from 'universal-cookie'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import IconButton from '@mui/material/IconButton'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import RestartAltIcon from '@mui/icons-material/RestartAlt'
import { CurrentPortalContext } from '../../../context/Shared/CurrentPortal.context'
import { CurrentUserContext } from '../../../context/Shared/CurrentUser.context'
import styles from './RoleSwitcher.module.scss'

const ROLES = ['Admin', 'Super User', 'Manager', 'User', 'Viewer', 'Guest', 'Education']
const DEFAULT_ROLE = 'Admin'
const COOKIE_KEY = 'adminRoleOverride'
const cookies = new Cookies()

export default function RoleSwitcher () {
  const { me } = useContext(CurrentUserContext)
  const { portal, setPortal } = useContext(CurrentPortalContext)
  const [expanded, setExpanded] = useState(false)

  if (!me?.admin) return null

  const currentRole = portal.role || DEFAULT_ROLE
  const isOverridden = currentRole !== DEFAULT_ROLE

  const handleRoleChange = (e) => {
    const role = e.target.value
    setPortal({ ...portal, role })
    if (role === DEFAULT_ROLE) {
      cookies.remove(COOKIE_KEY, { path: '/' })
    } else {
      cookies.set(COOKIE_KEY, role, { path: '/', maxAge: 60 * 60 * 24 * 7 })
    }
  }

  const handleReset = () => {
    setPortal({ ...portal, role: DEFAULT_ROLE })
    cookies.remove(COOKIE_KEY, { path: '/' })
  }

  return (
    <div className={styles.container}>
      {!expanded
        ? (
        <IconButton
          className={`${styles.toggleButton} ${isOverridden ? styles.toggleButtonActive : ''}`}
          onClick={() => setExpanded(true)}
          size='small'
        >
          <KeyboardArrowDownIcon fontSize='small' />
        </IconButton>
          )
        : (
        <div className={styles.bar}>
          <IconButton
            className={styles.collapseButton}
            onClick={() => setExpanded(false)}
            size='small'
          >
            <KeyboardArrowUpIcon fontSize='small' />
          </IconButton>
          <span className={styles.label}>Viewing as:</span>
          <Select
            value={currentRole}
            onChange={handleRoleChange}
            size='small'
            className={styles.select}
            MenuProps={{ className: styles.menu }}
          >
            {ROLES.map((role) => (
              <MenuItem key={role} value={role}>
                {role}
              </MenuItem>
            ))}
          </Select>
          {isOverridden && (
            <IconButton
              className={styles.resetButton}
              onClick={handleReset}
              size='small'
              title='Reset to Admin'
            >
              <RestartAltIcon fontSize='small' />
            </IconButton>
          )}
        </div>
          )}
    </div>
  )
}
